import React from "react";

const LANGUAGES = [
  { value: "italian", label: "Italian" },
  { value: "english", label: "English" },
  { value: "both", label: "Both languages" },
];

/** Single-choice language picker for guided visits (radio buttons). */
export const GuidedLanguageRadios = ({ value, onChange, name = "guided-visit-language" }) => (
  <div role="radiogroup" aria-label="Guided visit language" className="grid grid-cols-1 sm:grid-cols-3 gap-2" data-testid="guided-visit-language">
    {LANGUAGES.map((l) => {
      const checked = value === l.value;
      return (
        <label
          key={l.value}
          className={`flex items-center gap-2 px-3 py-2 rounded-md border cursor-pointer transition-colors ${
            checked ? "border-emerald-500 bg-emerald-50 text-emerald-900 font-medium" : "border-slate-200 bg-white hover:bg-slate-50 text-slate-800"
          }`}
          data-testid={`guided-visit-lang-${l.value}`}
        >
          <input
            type="radio"
            name={name}
            value={l.value}
            checked={checked}
            onChange={() => onChange(l.value)}
            className="accent-emerald-600 shrink-0"
            data-testid={`guided-visit-lang-radio-${l.value}`}
          />
          <span className="text-sm">{l.label}</span>
        </label>
      );
    })}
  </div>
);
